module.exports = __webpack_public_path__ + "static/media/bfluid.97e7f550.png";